// The `hidden` attribute alone isn't reliable here: echo-ui's `.btn { display:
// inline-block }` rule has the same specificity as the normalize.scss
// `[hidden] { display: none }` rule, and loads after it, so it wins the
// cascade tie on any `.btn`-classed element. Setting the inline style
// directly avoids depending on that ordering.
export function setHidden(element, hidden) {
  element.hidden = hidden
  element.style.display = hidden ? "none" : ""
}
